var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3e %3cg fill='none' fillRule='evenodd'%3e %3crect width='24' height='24' fillRule='nonzero' rx='4'/%3e %3cpath transform='matrix(1 0 0 -1 0 25.18)' fill='currentColor' id='9rc8jr3gba' d='M12.081 12.235L7.117 17.18 5 15.055 12.081 8 19.117 15.011 17 17.136z'/%3e %3c/g%3e%3c/svg%3e";

export default img;
//# sourceMappingURL=chevron-big.svg.js.map
